import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { shareContent } from '../../utils/shareUtils';
import './ReferralEventPage.css';

const ReferralEventPage = () => {
  const navigate = useNavigate();
  const [shareMessage, setShareMessage] = useState('');

  // 채널톡 열기 함수
  const openChannelTalk = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'referral_apply_click', {
        event_category: 'Events',
        event_label: 'referral_detail_page',
        value: 1
      });
    }

    if (window.ChannelIO) {
      window.ChannelIO('show');
    } else {
      window.location.href = 'mailto:angel@plactical.com?subject=[지인 추천 이벤트] 동료 교사 추천 이벤트 참여';
    }
  };

  const goBack = () => {
    navigate('/events');
  };

  // 이벤트 공유 함수
  const handleShareEvent = async () => {
    const shareData = {
      title: '왓퀴즈 지인 추천 이벤트 - Pro 구독 30일 무료!',
      text: '동료 교사를 왓퀴즈에 추천하고 Pro 구독 30일을 무료로 받아보세요! 교사용 무료 AI 플랫폼',
      url: `${window.location.origin}/events/referral`
    };

    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'referral_share_click', {
        event_category: 'Events',
        event_label: 'referral_page_share',
        value: 1
      });
    }

    const result = await shareContent(shareData);
    
    if (result.success) {
      setShareMessage('이벤트가 공유되었습니다!');
    } else if (result.error) {
      setShareMessage(result.error.includes('복사') ? 'URL이 복사되었습니다!' : '공유에 실패했습니다.');
    }

    setTimeout(() => setShareMessage(''), 3000);
  };

  const benefits = [
    {
      title: 'PRO 30일 무료',
      description: '추천 성공 시 즉시 적용'
    },
    {
      title: '무제한 추천',
      description: '횟수 제한 없이 혜택 누적 가능'
    },
    {
      title: '우수 추천인 특별 혜택',
      description: '월 5명 이상 추천 시 추가 혜택 제공'
    }
  ];

  return (
    <div className="referral-event-page">
      <Helmet>
        <title>지인 추천 이벤트 - 왓퀴즈</title>
        <meta name="description" content="동료 교사를 왓퀴즈에 초대하고 Pro 구독 30일을 무료로 받으세요!" />
        <meta property="og:title" content="지인 추천 이벤트 - 왓퀴즈" />
        <meta property="og:description" content="동료 교사를 왓퀴즈에 초대하고 Pro 구독 30일을 무료로 받으세요!" />
      </Helmet>

      {/* 헤더 섹션 */}
      <section className="referral-header">
        <div className="container">
          <button className="back-button" onClick={goBack}>
            ← 이벤트 목록
          </button>
          
          <div className="page-title-section">
            <div className="referral-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="8.5" cy="7" r="4"></circle>
                <line x1="20" y1="8" x2="20" y2="14"></line>
                <line x1="23" y1="11" x2="17" y2="11"></line>
              </svg>
            </div>
            <h1 className="referral-title">지인 추천</h1>
            <p className="referral-subtitle">동료 교사를 초대하고 PRO 30일을 받으세요</p>
          </div>
        </div>
      </section>

      {/* 혜택 섹션 - Value First */}
      <section className="referral-benefits">
        <div className="container">
          <h2>추천 혜택</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <span className="benefit-num">{index + 1}</span>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 참여 방법 섹션 */}
      <section className="referral-how">
        <div className="container">
          <h2>이렇게 진행돼요</h2>
          <div className="how-steps">
            <div className="how-step">
              <div className="step-num">1</div>
              <div className="step-text">
                <h3>동료에게 왓퀴즈 소개</h3>
                <p>함께 일하는 선생님에게 왓퀴즈를 알려주세요</p>
              </div>
            </div>
            <div className="how-step">
              <div className="step-num">2</div>
              <div className="step-text">
                <h3>추천인 코드 공유</h3>
                <p>내 추천인 코드를 동료에게 전달해요</p>
              </div>
            </div>
            <div className="how-step">
              <div className="step-num">3</div>
              <div className="step-text">
                <h3>코드 입력 확인</h3>
                <p>동료가 추천인 코드를 입력하면 완료!</p>
              </div>
            </div>
            <div className="how-step">
              <div className="step-num">4</div>
              <div className="step-text">
                <h3>PRO 30일 자동 적용</h3>
                <p>확인 후 바로 혜택이 적용돼요</p>
              </div>
            </div>
          </div>

          <div className="how-note">
            <p>왓퀴즈 가입 후 이용 중인 현직 교사라면 누구나 참여할 수 있어요</p>
          </div>
        </div>
      </section>

      {/* CTA 섹션 */}
      <section className="referral-apply">
        <div className="container">
          <div className="apply-content">
            <h2>지금 바로 참여하세요</h2>
            <p>추천 완료 후 채널톡으로 알려주세요</p>

            <div className="button-group">
              <button className="apply-button" onClick={openChannelTalk}>
                추천 완료 신청하기
              </button>
              
              <button className="share-button" onClick={handleShareEvent}>
                이벤트 공유하기
              </button>
            </div>

            {shareMessage && (
              <div className="share-message">
                {shareMessage}
              </div>
            )}

            <p className="apply-note">
              * 추천인 코드 입력 확인 후 3일 내 혜택이 적용됩니다
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReferralEventPage;
